import React from 'react';
import './Footer.css';
import { FaInstagram } from 'react-icons/fa';


const handleAnchorClick = (e, href) => {
  e.preventDefault();
  const target = document.querySelector(href);
  if (target) target.scrollIntoView({ behavior: 'smooth' });
};

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo"><em>Go</em>Snap</div>
          <p className="footer-desc">India's fastest on-demand creator booking platform. Professional content, instantly delivered.</p>
          <div className="footer-made">Made with ❤️ in Hyderabad</div>
        </div>

        {/* Platform */}
        <div>
          <div className="footer-col-h">Platform</div>
          <div className="footer-links">
            <a href="#">Browse Creators</a>
            <a href="#how" onClick={(e) => handleAnchorClick(e, '#how')}>How It Works</a>
            <a href="#pricing" onClick={(e) => handleAnchorClick(e, '#pricing')}>Pricing</a>
            <a href="#">GoSnap Pro</a>
          </div>
        </div>

        {/* Creators */}
        <div>
          <div className="footer-col-h">Creators</div>
          <div className="footer-links">
            <a href="#creators-join" onClick={(e) => handleAnchorClick(e, '#creators-join')}>Join as Creator</a>
            <a href="#">Creator Dashboard</a>
            <a href="#">Earn with GoSnap</a>
            <a href="#">Creator Academy</a>
          </div>
        </div>

        {/* Company */}
        <div>
          <div className="footer-col-h">Company</div>
          <div className="footer-links">
            <a href="#">About Us</a>
            <a href="#">Blog</a>
            <a href="#">Careers</a>
            <a href="#contact" onClick={(e) => handleAnchorClick(e, '#contact')}>Contact</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copy">© 2026 GoSnap Technologies Pvt. Ltd. · Privacy · Terms</div>
        <div className="footer-socials">  <a    href="https://www.instagram.com/go._snap/"    target="_blank"    rel="noopener noreferrer"    className="soc"  > 
           <FaInstagram size={18} />  </a></div>
      </div>
    </div>
  </footer>
);

export default Footer;
